// 韩语
export default {
  Login: {
    Title: "계정에 로그인",
    describe: "로그인하거나 계정을 생성하여 시작하십시오.",
    Google: "Google로 계속하기",
    Apple: "Apple로 계속하기",
    or: "또는",
    Emailplaceholder: "이메일 주소",
    Passwordplaceholder: "비밀번호",
    Login: "로그인",
    forgot: "비밀번호를 잊으셨나요?",
    notAccount: "Fineshare 계정이 없으신가요?",
    Signup: "가입하기",
    InvalidEmail: "잘못된 이메일 형식입니다.",
    InvalidPassword: "비밀번호는 6자 이상이어야 합니다.",
    loading: "로딩 중...",
    login: "로그인",
    errorText: "로그인 실패, 사용자 이름과 비밀번호를 확인하세요.",
  },
  signup: {
    Title: "계정 만들기",
    describe: "몇 초 만에 Fineshare 계정을 만드세요.",
    Google: "Google로 가입하기",
    Apple: "Apple로 가입하기",
    or: "또는",
    Emailplaceholder: "이메일 주소 입력",
    Passwordplaceholder: "6자리 비밀번호 입력",
    Already: "이미 계정이 있나요?",
    Login: "로그인",
    By: "계정을 생성함으로써 저는 다음에 동의한 것으로 간주됩니다",
    Privacy: "개인정보 처리방침",
    Terms: "이용약관",
    and: "그리고",
    signupText: "계정 만들기",
    InvalidEmail: "잘못된 이메일 형식입니다.",
    InvalidPassword: "비밀번호는 6자 이상이어야 합니다.",
    loading: "로딩 중...",
    passwordError: "이 이메일 주소는 이미 등록되었습니다.",
    again: "너무 많은 요청을 하셨습니다. 나중에 다시 시도해 주세요.",
    Registration: "등록 실패, 이메일과 비밀번호를 확인하세요.",
    hasRegistered: "이 이메일 주소는 이미 등록되었습니다.",
  },
  Home: {
    Welcome: "Fineshare 계정 센터에 오신 것을 환영합니다",
  },
};
